import(/* webpackMode: "eager" */ "/opt/buildhome/repo/inversum/src/app/faq/page.tsx");
